import { createCn } from "cnfast";

export const cn = createCn({});
